import gql from 'graphql-tag';

export const DELETE_ACTION = gql`
  mutation deleteAction($actionId: Int!) {
    questionAction {
      removeAction(actionId: $actionId)
    }
  }
`;
